/** Enums */
import { AssetsPaths } from '@shared/enums/assets-paths.enum';

export const LOGIN_LOGS = {
  header: `${AssetsPaths.LOGOS}/beyond_insite_logo.svg`,
  footer: `${AssetsPaths.LOGOS}/sixense_vertical_black.png`,
};
